import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import Error from '../components/Error'
import ViewLayout, { classes } from '../components/ViewLayout'
import { ForbiddenAccessIcon } from '../icons'

const title = 'Signed Out'

const LoggedOut = (): JSX.Element => {
  const text = <p>You have been successfully signed out.</p>

  return (
    <ViewLayout>
      <section className={classes.wrappingBox}>
        <Grid item span={12}>
          <Error icon={<ForbiddenAccessIcon />} title={title} text={text} />
        </Grid>
      </section>
    </ViewLayout>
  )
}

export default LoggedOut
